// Cambio de moneda en la vista Créditos sin recargar la página. El servidor
// ya renderizó un panel por moneda (escalera, hoja de servicio y modales);
// acá solo se muestra el de la moneda elegida y la URL queda apuntando a
// ella, para que recargar o volver conserve la elección. La moneda se elige
// en un modal (<dialog>) que abre la píldora del encabezado, como en tarjetas
// (entrypoints/card_currency_selector.js).
//
// Los paneles viven dentro del #vue-app global, que Vue reemplaza al montar:
// por eso los listeners van DELEGADOS en `document` y los nodos se buscan al
// momento del cambio, nunca antes.

const ENTRADA = 'credits-currency-pane--entering';

function mostrar(panel) {
  panel.hidden = false;
  // Reinicia la animación de entrada aunque el panel ya la haya hecho antes.
  panel.classList.remove(ENTRADA);
  void panel.offsetWidth;
  panel.classList.add(ENTRADA);
}

// Deja visibles solo los paneles de la moneda. Devuelve false si el servidor
// no renderizó ninguno para ella: entonces hay que pedirle la página.
function mostrarPaneles(currency) {
  const paneles = Array.from(document.querySelectorAll('[data-credits-currency-pane]'));
  if (!paneles.some((panel) => panel.dataset.creditsCurrencyPane === currency)) return false;

  paneles.forEach((panel) => {
    if (panel.dataset.creditsCurrencyPane === currency) {
      mostrar(panel);
      return;
    }
    // Un modal abierto (se puede salir de él con el teclado) no queda
    // abierto y oculto: se cierra como con ESC, devolviendo el foco.
    panel.querySelectorAll('.credits-modal-toggle:checked').forEach((toggle) => {
      toggle.checked = false;
      toggle.dispatchEvent(new Event('change', { bubbles: true }));
    });
    panel.hidden = true;
  });
  return true;
}

function urlDeMoneda(currency) {
  const url = new URL(window.location.href);
  url.searchParams.set('currency', currency);
  return url;
}

function elegir(dialog, opcion) {
  const boton = document.querySelector('[data-credits-currency-trigger]');
  const currency = opcion.dataset.creditsCurrencyOption;
  dialog.close();
  if (!boton || currency === boton.value) return;
  if (!mostrarPaneles(currency)) {
    // Sin panel para esa moneda (la vista no muestra la escalera de las dos):
    // la arma el servidor, como hacía el selector antes.
    window.location.assign(urlDeMoneda(currency));
    return;
  }

  boton.value = currency;
  boton.querySelector('[data-credits-currency-code]').textContent = currency;
  const bandera = boton.querySelector('img');
  const banderaElegida = opcion.querySelector('img');
  if (bandera && banderaElegida) bandera.src = banderaElegida.src;
  dialog.querySelectorAll('[data-credits-currency-option]').forEach((otra) => {
    otra.setAttribute('aria-pressed', String(otra === opcion));
  });
  window.history.replaceState(window.history.state, '', urlDeMoneda(currency));
}

document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;
  const dialog = document.querySelector('[data-credits-currency-dialog]');
  if (!(dialog instanceof HTMLDialogElement)) return;

  if (event.target.closest('[data-credits-currency-trigger]')) {
    if (!dialog.open) dialog.showModal();
    dialog.querySelector('[data-credits-currency-option][aria-pressed="true"]')?.focus();
    return;
  }
  if (!dialog.contains(event.target)) return;
  if (event.target.closest('[data-credits-currency-close]')) {
    dialog.close();
    return;
  }
  const opcion = event.target.closest('[data-credits-currency-option]');
  if (opcion) {
    elegir(dialog, opcion);
    return;
  }
  // Un clic en el fondo le llega al <dialog> con coordenadas fuera del panel.
  if (event.target === dialog) {
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right ||
        event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
  }
});

// Al cerrarse (también con ESC) el foco vuelve a la píldora: Safari no la
// enfoca con el clic, así que el dialog no siempre sabría adónde volver.
document.addEventListener('close', (event) => {
  if (!event.target.matches?.('[data-credits-currency-dialog]')) return;
  document.querySelector('[data-credits-currency-trigger]')?.focus({ preventScroll: true });
}, true);

// El Tab da la vuelta dentro del modal en vez de salir a la barra del navegador.
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Tab') return;
  const dialog = event.target.closest?.('[data-credits-currency-dialog][open]');
  if (!dialog) return;
  const botones = [...dialog.querySelectorAll('button:not([disabled])')];
  const primero = botones[0];
  const ultimo = botones[botones.length - 1];
  if ((event.shiftKey && event.target === primero) || (!event.shiftKey && event.target === ultimo)) {
    event.preventDefault();
    (event.shiftKey ? ultimo : primero).focus();
  }
});

document.addEventListener('animationend', (event) => {
  if (event.target.classList && event.target.classList.contains(ENTRADA)) event.target.classList.remove(ENTRADA);
});
